import { type ReactNode } from "react";

interface GridProps {
  children: ReactNode;
  className?: string;
}

/**
 * Responsive scrollable grid for app cards.
 * - Mobile (<640px): 1 column
 * - Tablet (640px-1023px): 2 columns
 * - Laptop (1024px-1279px): 3 columns
 * - Desktop (1280px-1535px): 4 columns
 * - Large Desktop (1536px+): 5 columns
 */
const Grid = ({ children, className = "" }: GridProps) => (
  <div
    className={`grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 ${className}`}
  >
    {children}
  </div>
);

export default Grid;
